var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeCrossed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 17.89,
    viewBox: "0 0 24 17.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f1f28;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.177,6.47c-.043-.016-.091-.028-.135-.042L19.967,3.5l-.92-.919L2.077,19.554,3,20.473l2.266-2.265A15,15,0,0,0,12,19.636c9.547,0,12-7,12-7A11.244,11.244,0,0,0,17.177,6.47Zm-.92,1.06A4.675,4.675,0,0,1,12,14.192a4.586,4.586,0,0,1-2.163-.56L16,7.464C16.088,7.487,16.176,7.506,16.257,7.53ZM12,18.336a14.115,14.115,0,0,1-5.765-1.1L8.869,14.6A5.987,5.987,0,0,0,18,9.492a6.01,6.01,0,0,0-.161-1.363,9.933,9.933,0,0,1,4.746,4.506C21.9,14.047,19.212,18.336,12,18.336Z",
    transform: "translate(0 -2.583)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.013,16.747l.91-.909a8.821,8.821,0,0,1-2.531-3.2A9.229,9.229,0,0,1,6.18,8.055,6.024,6.024,0,0,0,6,9.492a5.932,5.932,0,0,0,1,3.27l.943-.942a4.545,4.545,0,0,1-.177-4.328A15.381,15.381,0,0,1,12,6.936c.276,0,.529.021.79.035l1.2-1.2A15.873,15.873,0,0,0,12,5.636a17.96,17.96,0,0,0-2.976.248,14.657,14.657,0,0,0-2.167.529A10.568,10.568,0,0,0,0,12.636,9.927,9.927,0,0,0,3.013,16.747Z",
    transform: "translate(0 -2.583)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCrossed);
export default __webpack_public_path__ + "static/media/eye-crossed.9289c68e.svg";
export { ForwardRef as ReactComponent };